import { Pagination, PaginationFilterDto } from "../../../types/Pagination";
import { SelectItemDto } from "../../../types/SelectItemDto";
import { ImprovementPlanActionFormDto, ImprovementPlanByStatusAndTypeLineChartDataDto, ImprovementPlanDemandListItemDto, ImprovementPlanFinalizeDto, ImprovementPlanFormDto, ImprovementPlanFormSelectorsDto, ImprovementPlanIndicatorsDto, ImprovementPlanListItemDto, ImprovementPlanStatusList } from "../types";
import { apiService } from "../../../services/api/apiService";
import { downloadCsvFile } from "../../../utils/downloadCsvFile";
import { DeleteReasonIdDto } from "../../../types/DeleteReasonIdDto";
import { SelectedFilter } from "../../../components/Filters/types";
import { ImprovementPlanGanttDto } from '../types';
const BASE_URL = "/improvementPlans";

export const getSelectorsData = async (): Promise<ImprovementPlanFormSelectorsDto> => 
    await apiService.get<ImprovementPlanFormSelectorsDto>(`${BASE_URL}/selectors-data`)

export const getImprovementPlans = async (
    body: PaginationFilterDto
): Promise<Pagination<ImprovementPlanListItemDto>> => 
    await apiService.post<PaginationFilterDto, Pagination<ImprovementPlanListItemDto>>(`${BASE_URL}/`, body)
    
export const getImprovementPlanDemands = async (
    improvementPlanId: number
): Promise<ImprovementPlanDemandListItemDto[]> =>
    await apiService.get<ImprovementPlanDemandListItemDto[]>(`${BASE_URL}/${improvementPlanId}/demands`)

export const getDemandsToAddInImprovementPlans = async (id: number | null, body: PaginationFilterDto): Promise<Pagination<ImprovementPlanDemandListItemDto>> =>
    await apiService.post<PaginationFilterDto, Pagination<ImprovementPlanDemandListItemDto>>(`${BASE_URL}/demands-to-add/${id}`, body)
    
export const deleteLogicImprovementPlan = async (improvementPlanId: number, body: DeleteReasonIdDto): Promise<void> => 
    await apiService.put<DeleteReasonIdDto, void>(`${BASE_URL}/delete/${improvementPlanId}`, body)

export const getImprovementPlanById = async (improvementPlanId: number): Promise<ImprovementPlanFormDto> =>
    await apiService.get<ImprovementPlanFormDto>(`${BASE_URL}/${improvementPlanId}`)

export const createImprovementPlan = async (body: ImprovementPlanFormDto): Promise<ImprovementPlanFormDto> =>
    await apiService.post<ImprovementPlanFormDto, ImprovementPlanFormDto>(`${BASE_URL}/create`, body)

export const updateImprovementPlan = async (improvementPlanId: number, body: ImprovementPlanFormDto): Promise<ImprovementPlanFormDto> =>
    await apiService.put<ImprovementPlanFormDto, ImprovementPlanFormDto>(`${BASE_URL}/${improvementPlanId}`, body)

export const exportImprovementPlansToCsv = async (filters: PaginationFilterDto): Promise<void> => {
    try {
        const result = await apiService.post<PaginationFilterDto, any>(`${BASE_URL}/exportToCsv`, filters, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        downloadCsvFile(result, "improvement_plans_export.csv");
    } catch (error) {
        console.error("Error downloading CSV", error);
        throw error;
    }
}

export const getImprovementPlanFinalizeOptions = async (): Promise<SelectItemDto[]> => 
    await apiService.get<SelectItemDto[]>("/improvementPlanFinalizeReasons/select");

export const getImprovementPlanFinalizeForm = async (improvementPlanId: number): Promise<ImprovementPlanFinalizeDto> => 
    await apiService.get<ImprovementPlanFinalizeDto>(`${BASE_URL}/finalize/${improvementPlanId}`);

export const finalizeImprovementPlan = async (improvementPlanId: number, body: ImprovementPlanFinalizeDto): Promise<void> =>
    await apiService.put<ImprovementPlanFinalizeDto, void>(`${BASE_URL}/finalize/${improvementPlanId}`, body)

export const getNumberOfPendingActions = async (improvementPlanId: number): Promise<number> => 
    await apiService.get<number>(`${BASE_URL}/pending-actions/${improvementPlanId}`);

export const getImprovementPlanDeleteReasonOptions = async (): Promise<SelectItemDto[]> => 
    await apiService.get<SelectItemDto[]>("/improvementPlanDeleteReasons/select");

export const getImprovementPlanPieChart = ( filters: SelectedFilter[], filterByUser: boolean): Promise<ImprovementPlanStatusList> =>
    apiService.post<SelectedFilter[], ImprovementPlanStatusList>(
        `${BASE_URL}/dashboard/pie-chart/status`,
        filters,
        {
            params: { filterByUser },
        }
    );

export const getImprovementPlanStatusAndTypeBarChart = (filters: SelectedFilter[], filterByUser: boolean): Promise<ImprovementPlanByStatusAndTypeLineChartDataDto[]> =>
    apiService.post<SelectedFilter[], ImprovementPlanByStatusAndTypeLineChartDataDto[]>(
        `${BASE_URL}/dashboard/bar-chart/status/type`,
        filters,
        {
            params: { filterByUser },
        }
    );

export const getImprovementPlanIndicators = (filters: SelectedFilter[], filterByUser: boolean): Promise<ImprovementPlanIndicatorsDto> =>
    apiService.post<SelectedFilter[], ImprovementPlanIndicatorsDto>(
        `${BASE_URL}/dashboard/indicators`,
        filters,
        {
            params: { filterByUser },
        }
    );

export const getImprovementPlansGantt = (filters: SelectedFilter[],filterByUser: boolean): Promise<ImprovementPlanGanttDto> =>
  apiService.post<SelectedFilter[], ImprovementPlanGanttDto>(
    `${BASE_URL}/dashboard/gantt`,
    filters,
    { params: { filterByUser } }
  );
export const getImprovementActionsFromAI = async (plan: ImprovementPlanFormDto): Promise<ImprovementPlanActionFormDto[]> => 
    await apiService.post<ImprovementPlanFormDto, ImprovementPlanActionFormDto[]>(`${BASE_URL}/actions-ai`, plan);

export const createProposedPlansFromAI = async () : Promise<void> =>
    await apiService.post<null, void>(`${BASE_URL}/proposed-ai`, null);
